import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";
const FeeTyoe = "/api/business/feeType";
const LicNumberCCDV = "/api/business/company-lic-number";

export default class DisManageService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllDispatch(querySearch): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van/search", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllDispatchV2(querySearch): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cong-van/filter?sort=id:desc&sort=cvDate:desc", {
          params: querySearch,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getDetailDispatch(receipt_id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/cong-van/${receipt_id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getAllCompaniesv1(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/companyList")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getAllCompaniesv2(querySearch): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/companies", {
          params: querySearch,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateDispatch(receipt_id, query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`/api/business/cong-van/${receipt_id}`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public deleteDispatch(query): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/cong-van`, { data: query })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-numbers")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllTypes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cong-van/types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(FeeTyoe, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AddDispatchs(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van", query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getStatus(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/cong-van/statuses`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //
  public getStatusId(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business//cong-van/${id}/statuses`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnLicensee() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-cpn-licenses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicnumbeCCDV(params?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/cert/lic-des?lbiType=${params.feeType}&type=${params.type}`)
        // .get("/api/business/cert/lic-number")
        .then((res) => {
          console.log(res);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // .put(`/api/business/cong-van/${receipt_id}`, query)
  // public NumberCV(query: any): Promise<any> {
  //   console.log("query", query);

  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .get(`/api/business/cong-van/numbers?cong_van_den=${query}`)
  //       // .get(`/api/business/cong-van/lic_numbers`)
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }
  public NumberCV(querySearch: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/cong-van/numbers/v2?`, {
          params: querySearch,
        })
        // .get(`/api/business/cong-van/lic_numbers`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getAllSubjects(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/cong-van/subjects`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public LicCpnbusinessSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public excelTlm(querySearch): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          "/api/business/cong-van/excel/v2",
          null,
          {
            params: querySearch,
            responseType: "blob",
          }
          // { responseType: "blob" }ss
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  /// import công văn
  public ImportCV(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van/import", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  //Trạng thái
  public updateStatus(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van/update/statuses", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  public CreateStatus(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van/statuses", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  public deleteStatus(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/cong-van/statuses/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public CreateAndUpdateStatus(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van/create-and-update-status", query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getDeadlineByQuater(query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/cong-van/get-deadline-by-quater", query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
